export const environment = {
  production: true,
  firebaseConfig : {
    apiKey: "AIzaSyCRQcSZoBnO_spolcxdX0WpShsXpNHjwEo",
    authDomain: "userslist-9e729.firebaseapp.com",
    databaseURL: "https://userslist-9e729.firebaseio.com",
    projectId: "userslist-9e729",
    storageBucket: "userslist-9e729.appspot.com",
    messagingSenderId: "325834377217",
    appId: "1:325834377217:web:89b810f1e6207d14c2d800"
  }
};
